import styled from 'styled-components'

import addPx from 'utils/addPx'

// TODO ek: replace with GOAT Grid once it's stable
const Grid = styled.div`
	display: grid;
	grid-template-columns: repeat(${p => p.cols?.sm || 1}, 1fr);
	gap: ${p => addPx(p.gap || 24)};

	${p => p.theme.above('medium')`
    grid-template-columns: repeat(${p => p.cols?.md || 2}, 1fr);
  `}

	${p => p.theme.above('large')`
    grid-template-columns: repeat(${p => p.cols?.lg || 4}, 1fr);
  `}

  ${p => p.theme.above('extraLarge')`
    grid-template-columns: repeat(${p => p.cols?.xl || 4}, 1fr);
  `}
`

export default Grid
